import { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import SubscriptionCard from '../components/subscriptions/SubscriptionCard';
import SubscriptionComparison from '../components/subscriptions/SubscriptionComparison';
import SubscriptionRegistration from '../components/subscriptions/SubscriptionRegistration';
import { loadSubscriptions } from '../utils/subscriptionApi';
import '../components/home/HomePage.css';
import '../styles/subscriptions.css';

export default function Subscriptions() {
  const [catalogue, setCatalogue] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState('connect');
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const load = async () => {
    setLoading(true);
    setError('');
    try { setCatalogue(await loadSubscriptions()); }
    catch (failure) { setError(failure.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!loading && catalogue && window.location.hash === '#subscription-plans') {
      document.getElementById('subscription-plans')?.scrollIntoView?.({ block: 'start' });
    }
  }, [loading, catalogue]);
  const choosePlan = id => {
    setSelectedPlan(id);
    setEnquiryOpen(true);
  };
  return (
    <main className="nh-home subscriptions-page">
      <SEO pageName="subscriptions" customData={{ title: 'Subscriptions', description: 'Compare Connect, Ignite, Ascend and Pinnacle. Find your learning community and enquire about a monthly plan.', canonical: '/subscriptions' }} />
      {loading && <div className="subscription-load-state" role="status">Loading subscription plans…</div>}
      {error && <div className="subscription-load-state"><h1>Let's reconnect.</h1><p role="alert">{error}</p><button className="subscription-button" onClick={load}>Retry loading plans</button></div>}
      {!loading && !error && catalogue && <>
        <section className="subscription-hero">
          <div className="subscription-hero-copy"><p className="subscription-eyebrow">{catalogue.page.eyebrow}</p><h1>{catalogue.page.title}</h1><p>{catalogue.page.description}</p><a className="subscription-button" href="#subscription-plans">Explore the plans <span aria-hidden="true">↓</span></a><span className="subscription-hero-note">Monthly plans. Meaningful progress.</span></div>
        </section>
        <div className="subscription-content">
          <section id="subscription-plans" aria-labelledby="subscription-plans-title">
            <div className="subscription-section-heading"><p className="subscription-eyebrow">A PATH FOR EVERY AMBITION</p><h2 id="subscription-plans-title">Choose your momentum.</h2><p>Start with connection. Grow with intention. All prices are in INR per month.</p></div>
            <div className="subscription-plan-grid">{catalogue.plans.map(plan => <SubscriptionCard key={plan.id} plan={plan} featureGroups={catalogue.featureGroups} onSelect={choosePlan} />)}</div>
          </section>
          <SubscriptionComparison plans={catalogue.plans} featureGroups={catalogue.featureGroups} />
          <aside className="subscription-terms" aria-labelledby="subscription-terms-title"><h2 id="subscription-terms-title">{catalogue.page.termsTitle}</h2><ul><li>{catalogue.page.certificationTerms}</li><li>{catalogue.page.discountTerms}</li><li>{catalogue.page.interviewTerms}</li></ul></aside>
          <SubscriptionRegistration plans={catalogue.plans} selectedPlan={selectedPlan} onSelect={setSelectedPlan} page={catalogue.page} isOpen={enquiryOpen} onClose={() => setEnquiryOpen(false)} />
        </div>
      </>}
    </main>
  );
}
